import { mapMutations, mapActions } from "vuex";

const fileMetaEditorMixins = {
	data() {
		return {
			criticalHeaders: ['OPENING', 'PURCHASE', 'SALES', 'CLOSING'],
		};
	},
	computed: {
		isFileExcel() {
			if(this.selectedFile.extension && (this.selectedFile.extension === 'xls' || this.selectedFile.extension === 'xlsx')) {
				return true
			}
			return false
		}
	},
	methods: {
		...mapActions([
			'getAIGeneratedHeaderMapping',
		]),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),

		addOnlySalesAndClosingFlag(meta) {
			// ONLY_SALES_AND_CLOSING
			let headerMapping = meta.headerMapping;
			meta.ONLY_SALES_AND_CLOSING = false;
			if (meta.alternateMeta && meta.alternateMeta.enabled) {
				headerMapping = meta.alternateMeta.headerMapping;
				meta.alternateMeta.ONLY_SALES_AND_CLOSING = false;
			}
			let count = 0;
			for (let i of Object.values(headerMapping)) {
				if (this.criticalHeaders.includes(i)) {
					count++;
				}
			}

			if (count <= 2) {
				meta.ONLY_SALES_AND_CLOSING = true;
				if (meta.alternateMeta.enabled) {
					meta.alternateMeta.ONLY_SALES_AND_CLOSING = true;
				}
			}
			return meta;
		},

		async isPythonScriptConvertable() {
			let meta = JSON.parse(this.editorCode);
			let data = await this.checkPythonScriptConvertable({
				idHeader: JSON.stringify(meta.identificationHeaders),
				uuid: this.selectedFile.uuid,
			});
			let reader = new FileReader();
			reader.onload = () => {
				let responseData;
				try {
					responseData = JSON.parse(reader.result);
				} catch (e) {
					// ignore json parse error as response is not json
					// console.error(e);
				}
				if (typeof responseData !== 'object') {
					try {
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.selectedFile.uuid + '.xlsx'); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.openSnackbar({
							text: 'Downloading output file!',
							color: 'success',
						});
					} catch (e) {
						this.openSnackbar({ text: 'Could not download output file' });
					}
				} else {
					if (responseData && responseData.ok) {
						this.openSnackbar({
							text: responseData.isPythonScriptConvertable
								? 'Header found, Can convert file!'
								: 'CANNOT CONVERT',
							color: responseData.isPythonScriptConvertable
								? 'success'
								: 'error',
						});
					} else if (responseData && responseData.hasOwnProperty('message')) {
						this.openSnackbar({
							text: responseData.message,
							color: 'error',
						});
					} else {
						this.openSnackbar({ text: 'Could not check', color: 'error' });
					}
				}
			};
			reader.readAsText(data);
		},

		async downloadPythonScriptConvertableOutput() {
			let meta = JSON.parse(this.editorCode);
			let data = await this.downloadPythonScriptOutput({
				idHeader: JSON.stringify(meta.identificationHeaders),
				uuid: this.selectedFile.uuid,
			});
			let reader = new FileReader();
			reader.onload = () => {
				let responseData;
				try {
					responseData = JSON.parse(reader.result);
				} catch (e) {
					// ignore json parse error as response is not json
					// console.error(e);
				}
				if (typeof responseData !== 'object') {
					try {
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.selectedFile.uuid + '.xlsx'); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.openSnackbar({
							text: 'Downloading output file!',
							color: 'success',
						});
					} catch (e) {
						this.openSnackbar({ text: 'Could not download output file' });
					}
				} else {
					if (responseData && responseData.ok) {
						this.openSnackbar({
							text: responseData.isPythonScriptConvertable
								? 'Header found, Can convert file!'
								: 'CANNOT CONVERT',
							color: responseData.isPythonScriptConvertable
								? 'success'
								: 'error',
						});
					} else {
						this.openSnackbar({ text: 'Could not check' });
					}
				}
			};
			reader.readAsText(data);
		},

		async downloadPDFMLAPIConvertableOutput() {
			let data = await this.downloadPDFMLAPIConvertableOutputAPICall({
				uuid: this.selectedFile.uuid,
			});
			let reader = new FileReader();
			reader.onload = () => {
				let responseData;
				try {
					responseData = JSON.parse(reader.result);
				} catch (e) {
					// ignore json parse error as response is not json
					// console.error(e);
				}
				if (typeof responseData !== 'object') {
					try {
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.selectedFile.uuid + '.xlsx'); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.openSnackbar({
							text: 'Downloading output file!',
							color: 'success',
						});
					} catch (e) {
						this.openSnackbar({ text: 'Could not download output file' });
					}
				} else {
					if (responseData && responseData.ok) {
						this.openSnackbar({
							text: 'Can download file!',
							color: 'success',
						});
					} else if (responseData && responseData.hasOwnProperty('message')) {
						this.openSnackbar({
							text: responseData.message,
							color: 'error',
						});
					} else {
						this.openSnackbar({ text: 'Could not check', color: 'error' });
					}
				}
			};
			reader.readAsText(data);
		},

		async downloadPDFGeminiConvertableOutput() {
			this.openLoaderDialog();
			let data = await this.downloadPDFGeminiConvertableOutputAPICall({
				uuid: this.selectedFile.uuid,
			});
			this.closeLoaderDialog();
			let reader = new FileReader();
			reader.onload = () => {
				let responseData;
				try {
					responseData = JSON.parse(reader.result);
				} catch (e) {
					// ignore json parse error as response is not json
					// console.error(e);
				}
				if (typeof responseData !== 'object') {
					try {
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.selectedFile.uuid + '.xlsx'); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.openSnackbar({
							text: 'Downloading output file!',
							color: 'success',
						});
					} catch (e) {
						this.openSnackbar({ text: 'Could not download output file' });
					}
				} else {
					if (responseData && responseData.ok) {
						this.openSnackbar({
							text: 'Can download file!',
							color: 'success',
						});
					} else if (responseData && responseData.hasOwnProperty('message')) {
						this.openSnackbar({
							text: responseData.message,
							color: 'error',
						});
					} else {
						this.openSnackbar({ text: 'Could not check', color: 'error' });
					}
				}
			};
			reader.readAsText(data);
		},

		async downloadXlsToXlsxConvertableOutput() {
			let meta = JSON.parse(this.editorCode);
			let data = await this.downloadXlsToXlsxConvertableOutputAPICall({
				idHeader: JSON.stringify(meta.identificationHeaders),
				uuid: this.selectedFile.uuid,
			});
			let reader = new FileReader();
			reader.onload = () => {
				let responseData;
				try {
					responseData = JSON.parse(reader.result);
				} catch (e) {
					// ignore json parse error as response is not json
					// console.error(e);
				}
				if (typeof responseData !== 'object') {
					try {
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.selectedFile.uuid + '.xlsx'); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.openSnackbar({
							text: 'Downloading output file!',
							color: 'success',
						});
					} catch (e) {
						this.openSnackbar({ text: 'Could not download output file' });
					}
				} else {
					if (responseData && responseData.ok) {
						this.openSnackbar({
							text: 'Can download file!',
							color: 'success',
						});
					} else if (responseData && responseData.hasOwnProperty('message')) {
						this.openSnackbar({
							text: responseData.message,
							color: 'error',
						});
					} else {
						this.openSnackbar({ text: 'Could not check', color: 'error' });
					}
				}
			};
			reader.readAsText(data);
		},

		async downloadPythonScriptDelimterConvertableOutput() {
			let meta = JSON.parse(this.editorCode);
			let data = await this.downloadPythonScriptOutput({
				idHeader: JSON.stringify(meta.identificationHeaders),
				uuid: this.selectedFile.uuid,
				isDelimiterConvertable: true,
			});
			let reader = new FileReader();
			reader.onload = () => {
				let responseData;
				try {
					responseData = JSON.parse(reader.result);
				} catch (e) {
					// ignore json parse error as response is not json
					// console.error(e);
				}
				if (typeof responseData !== 'object') {
					try {
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', this.selectedFile.uuid + '.xlsx'); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.openSnackbar({
							text: 'Downloading output file!',
							color: 'success',
						});
					} catch (e) {
						this.openSnackbar({ text: 'Could not download output file' });
					}
				} else {
					if (responseData && responseData.ok) {
						this.openSnackbar({
							text: responseData.isPythonScriptConvertable
								? 'Header found, Can convert file!'
								: 'CANNOT CONVERT',
							color: responseData.isPythonScriptConvertable
								? 'success'
								: 'error',
						});
					} else {
						this.openSnackbar({ text: 'Could not check' });
					}
				}
			};
			reader.readAsText(data);
		},

		async onGenerateHeaderMappingClick() {
			this.openLoaderDialog();
			let response = await this.getAIGeneratedHeaderMapping({
				uuid: this.selectedFile.uuid
			})
			this.closeLoaderDialog();
				
			if(response.ok) {
				let fileMetaConfig = JSON.parse(this.editorCode);
				fileMetaConfig.identificationHeaders = response.data.headers;
				fileMetaConfig.headerMapping = response.data.headerMapping;
				this.editorHandler.setValue(JSON.stringify(fileMetaConfig, null, 2));
			} else {
				this.openSnackbar({
					text: 'Could not generate header mapping',
				});
			}
		}
	},
};

export default fileMetaEditorMixins;
